import { Link, useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import Registration from '../assets/images/Registration.png';
import Doctor from '../assets/images/Doctor.png';
import Feedback from '../assets/images/feedback.png';
import Faq1 from '../assets/images/faq1.png';
import { Wallet, AlertCircle } from 'lucide-react';

const Home = () => {
    const navigate = useNavigate();
    const [showAlert, setShowAlert] = useState(false);
    const [isKioskConfigured, setIsKioskConfigured] = useState(false);

    useEffect(() => {
        // Check if kiosk machine is configured
        const kioskMachineNo = localStorage.getItem('kiosk_machine_no');
        const siteCode = localStorage.getItem('site_code');

        if (kioskMachineNo && siteCode) {
            setIsKioskConfigured(true);
        } else {
            setIsKioskConfigured(false);
        }
    }, []);

    const handleNavigation = (e, path) => {
        const kioskMachineNo = localStorage.getItem('kiosk_machine_no');
        const siteCode = localStorage.getItem('site_code');

        if (!kioskMachineNo || !siteCode) {
            e.preventDefault();
            setShowAlert(true);
            setTimeout(() => setShowAlert(false), 5000);
            return;
        }

        // If configured, allow navigation
        navigate(path);
    };

    return (
        <div className="min-h-screen bg-gray-50 pb-8">
            {/* Alert Message */}
            {showAlert && (
                <div className="fixed top-4 left-1/2 transform -translate-x-1/2 z-50 w-full max-w-md px-4">
                    <div className="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 rounded-lg shadow-lg flex items-start gap-3">
                        <AlertCircle className="w-6 h-6 flex-shrink-0 mt-0.5" />
                        <div>
                            <p className="font-semibold">Kiosk Machine Not Configured</p>
                            <p className="text-sm mt-1">
                                Please configure kiosk machine number and site code first. Contact administrator.
                            </p>
                        </div>
                    </div>
                </div>
            )}

            {/* Row for Logos */}
            <div className="flex items-center justify-center px-4 sm:px-6 lg:px-8">
                {/* Powered By Logo in Center */}
                <div className="text-center py-6 sm:py-8 lg:py-10">
                    <img
                        src="/logo.jpg"
                        alt="Powered By Logo"
                        className="h-20 sm:h-24 lg:h-28 mx-auto object-contain"
                    />
                </div>
            </div>

            {/* Main Grid for All Cards */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6 px-4 sm:px-8 lg:px-16 mt-4 sm:mt-6">
                {/* New Registration Card */}
                <div
                    onClick={(e) => handleNavigation(e, '/patient-details')}
                    className={`bg-white shadow-lg rounded-lg p-4 sm:p-6 flex flex-col justify-center items-center hover:shadow-xl transition-shadow duration-300 transform hover:scale-105 ${!isKioskConfigured ? 'opacity-60 cursor-not-allowed' : 'cursor-pointer'}`}
                >
                    <img
                        src={Registration}
                        alt="Registration"
                        className="h-32 w-32 sm:h-40 sm:w-40 lg:h-56 lg:w-56 object-contain"
                    />
                    <h2 className="text-2xl sm:text-3xl lg:text-4xl font-semibold text-center text-black mt-4 sm:mt-5">
                        Registration
                    </h2>
                    <p className="mt-2 sm:mt-3 text-base sm:text-lg lg:text-2xl text-center text-gray-600 px-2">
                        Registration Entry
                    </p>
                </div>

                {/* OPD Schedule Card */}
                <div
                    onClick={(e) => handleNavigation(e, '/opd-schedule')}
                    className={`bg-white shadow-lg rounded-lg p-4 sm:p-6 flex flex-col justify-center items-center hover:shadow-xl transition-shadow duration-300 transform hover:scale-105 ${!isKioskConfigured ? 'opacity-60 cursor-not-allowed' : 'cursor-pointer'}`}
                >
                    <img
                        src="doctor.png"
                        alt="Download"
                        className="h-32 w-32 sm:h-40 sm:w-40 lg:h-56 lg:w-56 object-contain"
                    />
                    <h2 className="text-2xl sm:text-3xl lg:text-4xl font-semibold text-center text-black mt-4 sm:mt-5">
                        OPD Calender
                    </h2>
                    <p className="mt-2 sm:mt-3 text-base sm:text-lg lg:text-2xl text-center text-gray-600 px-2">
                        Department Wise Doctors availability
                    </p>
                </div>

                {/* Already Registered Card */}
                <div
                    onClick={(e) => handleNavigation(e, '/login')}
                    className={`bg-white shadow-lg rounded-lg p-4 sm:p-6 flex flex-col justify-center items-center hover:shadow-xl transition-shadow duration-300 transform hover:scale-105 ${!isKioskConfigured ? 'opacity-60 cursor-not-allowed' : 'cursor-pointer'}`}
                >
                    <img
                        src={Doctor}
                        alt="Doctor"
                        className="h-32 w-32 sm:h-40 sm:w-40 lg:h-56 lg:w-56 object-contain"
                    />
                    <h2 className="text-2xl sm:text-3xl lg:text-4xl font-semibold text-center text-black mt-4 sm:mt-5">
                        Already Registered
                    </h2>
                    <p className="mt-2 sm:mt-3 text-base sm:text-lg lg:text-2xl text-center text-gray-600 px-2">
                        Appointment Booking, Lab & Rad Reports, bills
                    </p>
                </div>

                {/* Online Payment Card */}
                {/* <div
                    onClick={(e) => handleNavigation(e, '/online-payment')}
                    className={`bg-white shadow-lg rounded-lg p-4 sm:p-6 flex flex-col justify-center items-center hover:shadow-xl transition-shadow duration-300 transform hover:scale-105 ${!isKioskConfigured ? 'opacity-60 cursor-not-allowed' : 'cursor-pointer'}`}
                >
                    <Wallet className="h-32 w-32 sm:h-40 sm:w-40 lg:h-56 lg:w-56 text-gray-500" />
                    <h2 className="text-2xl sm:text-3xl lg:text-4xl text-center text-black mt-4 sm:mt-5 font-normal">
                        Book Service
                    </h2>
                </div> */}

                {/* Online Deposit Card */}
                <div
                    onClick={(e) => handleNavigation(e, '/online-deposit')}
                    className={`bg-white shadow-lg rounded-lg p-4 sm:p-6 flex flex-col justify-center items-center hover:shadow-xl transition-shadow duration-300 transform hover:scale-105 ${!isKioskConfigured ? 'opacity-60 cursor-not-allowed' : 'cursor-pointer'}`}
                >
                    <Wallet className="h-32 w-32 sm:h-40 sm:w-40 lg:h-56 lg:w-56 text-gray-500" />
                    <h2 className="text-2xl sm:text-3xl lg:text-4xl text-center text-black mt-4 sm:mt-5 font-normal">
                        Advance Payment
                    </h2>
                </div>

                {/* Feedback Card */}
                <Link
                    to="https://feedback.kimsbbsr.co.in/feedback/qr-feedback"
                    className="bg-white shadow-lg rounded-lg p-4 sm:p-6 flex flex-col justify-center items-center hover:shadow-xl transition-shadow duration-300 transform hover:scale-105"
                >
                    <img
                        src={Feedback}
                        alt="Feedback"
                        className="h-32 w-32 sm:h-40 sm:w-40 lg:h-56 lg:w-56 object-contain"
                    />
                    <h2 className="text-2xl sm:text-3xl lg:text-4xl text-center text-black mt-4 sm:mt-5 font-normal">
                        Feedback
                    </h2>
                </Link>

                {/* FAQs Card */}
                <div
                    onClick={(e) => handleNavigation(e, '/faqs')}
                    className={`bg-white shadow-lg rounded-lg p-4 sm:p-6 flex flex-col justify-center items-center hover:shadow-xl transition-shadow duration-300 transform hover:scale-105 ${!isKioskConfigured ? 'opacity-60 cursor-not-allowed' : 'cursor-pointer'}`}
                >
                    <img
                        src={Faq1}
                        alt="Faqs"
                        className="h-32 w-32 sm:h-40 sm:w-40 lg:h-56 lg:w-56 object-contain"
                    />
                    <h2 className="text-2xl sm:text-3xl lg:text-4xl text-center text-black mt-4 sm:mt-5 font-normal">
                        FAQs
                    </h2>
                </div>
            </div>
        </div>
    );
};

export default Home;